module.exports = __webpack_public_path__ + "img/man-wearing-gray-suit-besides-woman-2422276.63bc7be5.jpg";